import "./userinfo.css";
import React, { memo, useCallback, useEffect, useState } from "react";
import { Box, Divider, Paper } from "@mui/material";
import { useGetUserDetailsMutation } from "../../../Redux/service/AllEmpData";
import LoadingSpinner from "../../../components/Loaders/NETWORKCALLLOADER/LoadingSpinner";
import { toast } from "react-toastify";
import { GetCookie } from "../../../Libraries/Media";
const UserInfo = () => {
  const [userinfo, { isLoading }] = useGetUserDetailsMutation();
  const [data, setdata] = useState(null);

  const UseInfo = useCallback(async () => {
    try {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("function", 'GET_CUSTOMER_DETAILS');
      payload.append("session_id", await GetCookie("session_id") )

      const res = await userinfo(payload).unwrap();
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Customer available"
      ) {
        setdata(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  }, [userinfo]);

  useEffect(() => {
    UseInfo();
  }, [UseInfo]);

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box
        sx={{ flexGrow: 1, mr: 3, mt: 2 }}
        height="84vh"
        component={Paper}
        borderRadius={2}
      >
        {data ? (
          <>
            <div className="row g-0 p-4">
              <div className="col">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    color: "#1A75E8",
                    marginRight: "15px",
                  }}
                >
                  {" "}
                  Package:
                </span>
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    color: "#EE6767",
                  }}
                >
                  {data?.txt_customer_current_plan}
                </span>
              </div>
            </div>
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                User Name
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.txt_customer_id}
              </div>
            </div>
            <Divider />
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                NTL NO
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.txt_customer_ntl_no}
              </div>
            </div>
            <Divider />
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                Email
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.txt_customer_email}
              </div>
            </div>
            <Divider />
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                No. of Screens
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.num_allocated_screens + " "}
                Screens
              </div>
            </div>
            <Divider />
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                Package Started Date
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.dte_created_date}
              </div>
            </div>
            <Divider />
            <div className="row g-0 px-4">
              <div
                className="col-4"
                style={{ color: "#1A75E8", fontWeight: "bold" }}
              >
                Package Expiry Date
              </div>
              <div className="col" style={{ color: "#000000" }}>
                {data?.dte_customer_trial_date_end}
              </div>
            </div>
            {/* <Divider />
            <div className="row g-0 p-4">
              <div
                className="col d-flex justify-content-end"
                style={{ color: "#1A75E8" }}
              >
                <Button
                  variant="contained"
                  onClick={() => navigate("/packageupgrade")}
                >
                  Upgrade Now
                </Button>
              </div>
            </div> */}
          </>
        ) : null}
      </Box>
    </>
  );
};

export default memo(UserInfo);
